export const SITE_COMPANY_NAME = "Soki Creative LLC";
export const SITE_CONTACT_URL = "https://soki-creative.com";
export const SITE_CONTACT_LABEL = "soki-creative.com";
export const SITE_PRODUCT_NAME = "BurnChart AI";
export const SITE_LOGO_SRC = "/logo.svg";
export const SITE_LOGO_ALT = "BurnChart AI";
